import { OrgPartSchema } from 'types/clientV2/parts';
import { StockLocationSchemaLite } from 'types/clientV2/stockLocations';
import { StockLocation } from 'types/inventory';
import { OrgPart, Part, PartCore } from 'types/part';
import _ from 'lodash';

export const getPart = (record: {
  part?: OrgPart | OrgPartSchema | Part | PartCore | string | null;
}) => {
  if (typeof record.part === 'string') {
    return record.part;
  }
  if (record.part?.id) {
    const manufacturer =
      _.get(record.part, 'manufacturer') || _.get(record.part, 'mfg');
    const customId = _.get(record.part, 'customId');
    const mpn = _.get(record.part, 'mpn');
    return `${manufacturer ? `${manufacturer} ` : ''}${mpn || ''}${
      mpn && customId ? ` (${customId})` : customId ? `${customId}` : ''
    }`;
  }
  return undefined;
};

export const getOrgPartOrDescription = (record: {
  orgPart?: OrgPart | OrgPartSchema | Part | PartCore | string | null;
  description?: string | null;
}) => {
  if (typeof record.orgPart === 'string') {
    return record.orgPart;
  }
  if (record.orgPart?.id) {
    return getPart({ part: record.orgPart });
  }
  return record.description;
};

export const getV2OrgPartOrDescription = (record: {
  v2OrgPart?: OrgPart | OrgPartSchema | Part | PartCore | string | null;
  description?: string | null;
}) => {
  if (typeof record.v2OrgPart === 'string') {
    return record.v2OrgPart;
  }
  if (record.v2OrgPart?.id) {
    return getPart({ part: record.v2OrgPart });
  }
  return record.description;
};

export const getPartOrDescription = (record: {
  part?: OrgPart | OrgPartSchema | Part | PartCore | string | null;
  description?: string | null;
}) => {
  if (typeof record.part === 'string') {
    return record.part;
  }
  if (record.part?.id) {
    return getPart({ part: record.part });
  }
  return record.description;
};

export const getAddressLabel = (
  address: StockLocation | StockLocationSchemaLite | null
) => {
  if (!address) {
    return '';
  }
  return (
    address.externalName ||
    address.name ||
    address.address?.company ||
    address.address?.name ||
    '-'
  );
};

export const getV2OrgPartFromV2OrgParts = (record: {
  v2OrgPart: OrgPartSchema['id'];
  v2OrgParts: OrgPartSchema[];
}) => {
  if (!record?.v2OrgPart) {
    return '';
  }
  const foundPart = _.find(
    record.v2OrgParts,
    (part) => part.id === record.v2OrgPart
  );
  if (!foundPart) {
    return '';
  }

  const manufacturer =
    _.get(foundPart, 'manufacturer') || _.get(foundPart, 'mfg');
  const customId = _.get(foundPart, 'customId');
  const mpn = _.get(foundPart, 'mpn');
  return `${manufacturer ? `${manufacturer} ` : ''}${mpn || ''}${
    mpn && customId ? ` (${customId})` : customId ? `${customId}` : ''
  }`;
};
